<div class="form-control" pTooltip="Vaga onde a embarcação fica guardada" tooltipPosition="bottom">
    <label>{{ 'VACANCY' | translate }} *</label>
    <p-dropdown appendTo="body" [filter]="true" [options]="vacancies"
        name="boatVacancy" tooltipPosition="bottom" [(ngModel)]="vacancy" (onChange)="selectVacancyOrigin($event)">
    </p-dropdown>
</div>